'use client';

import { sendNewEvent } from '@/app/_utils/events';
import { ApiWebApp } from '@/lib/citibox/sdk/ApiWebApp';
import { getClientContext } from '@/lib/citibox/sdk/clientContext';
import { AnalyticsProperties } from '@/lib/google/AnalyticsProperties';
import { compactObject } from '@/lib/utils';

export type AnalyticsEvent = {
  eventName: string;
  payload: Record<string, AnalyticsProperty>;
};

type AnalyticsProperty = string | number | boolean | null | undefined;

type CitiboxSdkInfo = {
  sdk_version: string;
  nwap_version: string;
};

export class AnalyticsFromServer {
  properties: Map<string, AnalyticsProperty>;

  constructor() {
    this.properties = new Map();

    ApiWebApp.addInfoObserver((data: CitiboxSdkInfo) => {
      if (data.sdk_version) {
        this.properties.set('sdk_version', data.sdk_version);
      }
      if (data.nwap_version) {
        this.properties.set('nwap_version', data.nwap_version);
      }
    });
  }

  addProperty(key: string, value: AnalyticsProperty) {
    this.properties.set(key, value);
  }

  clearProperties() {
    this.properties.clear();
  }

  async sendEvent(eventName: string, payload: Record<string, AnalyticsProperty> = {}) {
    const ev = {
      eventName,
      payload: compactObject({
        [AnalyticsProperties.CLIENT_CONTEXT]: getClientContext(),
        ...Object.fromEntries(this.properties.entries()),
        ...payload
      })
    };
    sendNewEvent('analytics', ev, (ev: AnalyticsEvent) => {
      fetch('/api/analytics', { method: 'POST', body: JSON.stringify(ev) });
    });
  }
}
